// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Miql","questions":"styles_questions__3j0Xn","footer":"styles_footer__3kgPy"};